<template>
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.4714 0.695262C4.73175 0.955612 4.73175 1.37772 4.4714 1.63807L2.27614 3.83333H11.3333C11.7015 3.83333 12 4.13181 12 4.5C12 4.86819 11.7015 5.16667 11.3333 5.16667H2.27614L4.4714 7.36193C4.73175 7.62228 4.73175 8.04439 4.4714 8.30474C4.21106 8.56509 3.78894 8.56509 3.5286 8.30474L0.195654 4.9718L0.195262 4.97141C-0.0650874 4.71106 -0.0650874 4.28895 0.195262 4.0286L3.5286 0.695262C3.78894 0.434913 4.21106 0.434913 4.4714 0.695262Z" fill="#233C73" />
  </svg>
</template>
      
<script>
export default {
    name: 'IconArrowLeft',
};
</script>